const CashCollection = () => (
  <svg height="20" width="20" viewBox="0 0 32 32">
    <path
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M21.625 24.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      fill="transparent"
    />
    <path
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M23.5 22h2.25v-7.07c0-.28-.079-.556-.228-.794L22.44 9.955a1.5 1.5 0 0 0-1.272-.705H7.75a1.5 1.5 0 0 0-1.5 1.5V22H8.5M12.25 22h7.5"
      fill="transparent"
    />
    <path
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M10.375 24.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM17.5 14.5v-.463c0-.573-.464-1.037-1.037-1.037h-.927c-.572 0-1.036.459-1.036 1.031 0 .284.16.55.415.676l2.17 1.085a.75.75 0 0 1 .415.672c0 .572-.464 1.036-1.037 1.036h-.927a1.037 1.037 0 0 1-1.036-1.037V16M16 13v-1.5M16 19v-1.5"
      fill="transparent"
    />
    <path
      fill="#fff"
      d="M17.5 7A1.5 1.5 0 0 0 16 8.5V10h3V8.5A1.5 1.5 0 0 0 17.5 7"
    />
  </svg>
);

export default CashCollection;
